import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as LoaderFeatureState from './loader.state';

export const selectLoaderState =
  createFeatureSelector<LoaderFeatureState.LoaderState>(
    LoaderFeatureState.loaderFeatureKey
  );

export const selectActionType = createSelector(
  selectLoaderState,
  (state) => state && state.actionType
);

export const selectShowLoader = createSelector(
  selectLoaderState,
  (state) => state && state.showLoader
);
